import axios from 'axios'
import library from '../../../utils/Library'

export const updateUserApplicationInstanceAccess = async (data) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') +
    '/updateUserApplicationInstanceAccessEAuthz'
  return await axios({
    url: URL,
    method: 'PUT',
    data,
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
